import styled from 'styled-components';

export const Container = styled.div``;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
`;

export const HeaderTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => (theme.name === 'dark' ? '#ffffff' : '#0f172a')};
  margin: 0;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid
    ${({ theme }) => (theme.name === 'dark' ? '#334155' : '#e2e8f0')};
`;

export const SectionIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: ${({ theme }) => (theme.name === 'dark' ? '#1e40af' : '#dbeafe')};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => (theme.name === 'dark' ? '#93c5fd' : '#2563eb')};
`;

export const SectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => (theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const HelperText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => (theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  margin: 0 0 24px 0;
  line-height: 1.5;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SortableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .sortable-ghost {
    opacity: 0.4;
  }

  .sortable-chosen {
    box-shadow: 0 4px 16px
      ${({ theme }) =>
        theme.name === 'dark' ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0.12)'};
  }
`;

// Design 4: Compact Inline Row
export const InfoCardWrapper = styled.div`
  background: ${({ theme, disabled }) =>
    disabled
      ? theme.name === 'dark'
        ? 'rgba(30, 41, 59, 0.5)'
        : 'rgba(255, 255, 255, 0.5)'
      : theme.name === 'dark'
      ? '#1e293b'
      : '#ffffff'};
  border: 1px solid
    ${({ theme, disabled }) =>
      disabled
        ? theme.name === 'dark'
          ? '#252f3f'
          : '#f1f5f9'
        : theme.name === 'dark'
        ? '#334155'
        : '#e2e8f0'};
  border-radius: 8px;
  transition: all 0.2s ease;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  overflow: hidden;

  &:hover {
    border-color: ${({ theme, disabled }) =>
      disabled
        ? theme.name === 'dark'
          ? '#252f3f'
          : '#f1f5f9'
        : theme.name === 'dark'
        ? '#475569'
        : '#cbd5e1'};
  }
`;

export const InfoCard = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 12px;

  @media (max-width: 768px) {
    padding: 12px;
    gap: 8px;
    flex-wrap: wrap;
  }
`;

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'grab')};
  color: ${({ theme, disabled }) =>
    disabled
      ? theme.name === 'dark'
        ? '#475569'
        : '#cbd5e1'
      : theme.name === 'dark'
      ? '#64748b'
      : '#94a3b8'};
  flex-shrink: 0;
  padding: 4px;
  margin: -4px;
  border-radius: 4px;
  transition: color 0.15s ease;

  &:hover {
    color: ${({ theme, disabled }) =>
      disabled
        ? theme.name === 'dark'
          ? '#475569'
          : '#cbd5e1'
        : theme.name === 'dark'
        ? '#94a3b8'
        : '#64748b'};
  }

  &:active {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'grabbing')};
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

// Orange order badge like Design 4
export const OrderBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: linear-gradient(135deg, #fa4616, #ea580c);
  color: white;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 22px;
    height: 22px;
    font-size: 11px;
  }
`;

export const InfoIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: ${({ $plain }) => ($plain ? '0' : '8px')};
  background: ${({ theme, $plain, $category }) => {
    if ($category) return '#fa4616';
    if ($plain) return 'transparent';
    return theme.name === 'dark' ? '#1e40af' : '#dbeafe';
  }};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  color: ${({ theme }) => (theme.name === 'dark' ? '#93c5fd' : '#2563eb')};

  img {
    width: ${({ $category }) => ($category ? '20px' : '100%')};
    height: ${({ $category }) => ($category ? '20px' : '100%')};
    object-fit: ${({ $plain, $category }) =>
      $category || $plain ? 'contain' : 'cover'};
    filter: ${({ $category }) =>
      $category ? 'brightness(0) invert(1)' : 'none'};
  }

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
  }
`;

export const InfoContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const InfoName = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => (theme.name === 'dark' ? '#ffffff' : '#0f172a')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

// Neutral pills like Design 4 final version
export const ContentPills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;

  @media (max-width: 768px) {
    order: 10;
  }
`;

export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  font-size: 10px;
  font-weight: 600;
  border-radius: 20px;
  background: ${({ theme }) =>
    theme.name === 'dark' ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.06)'};
  color: ${({ theme }) =>
    theme.name === 'dark' ? 'rgba(255,255,255,0.85)' : 'rgba(0,0,0,0.65)'};
  border: 1px solid
    ${({ theme }) =>
      theme.name === 'dark' ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.1)'};
`;

// Preview button with text
export const PreviewButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme, expanded }) =>
    expanded ? '#ffffff' : theme.name === 'dark' ? '#94a3b8' : '#64748b'};
  background: ${({ theme, expanded }) =>
    expanded ? '#fa4616' : theme.name === 'dark' ? '#334155' : '#f1f5f9'};
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;

  &:hover {
    background: ${({ theme, expanded }) =>
      expanded ? '#e03d0d' : theme.name === 'dark' ? '#475569' : '#e2e8f0'};
    color: ${({ theme, expanded }) =>
      expanded ? '#ffffff' : theme.name === 'dark' ? '#ffffff' : '#0f172a'};
  }

  svg {
    transition: transform 0.2s ease;
    transform: ${({ expanded }) => (expanded ? 'rotate(180deg)' : 'rotate(0)')};
  }

  @media (max-width: 768px) {
    order: 11;
    margin-left: auto;
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    order: 5;
  }
`;

// Force line break on mobile after toggle
export const MobileBreak = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    flex-basis: 100%;
    height: 0;
    order: 9;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: ${({ theme }) => (theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  font-size: 16px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
`;

export const EmptyIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 12px;
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? 'rgba(250, 70, 22, 0.15)'
      : 'rgba(250, 70, 22, 0.08)'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fa4616;
  margin-bottom: 16px;
`;

export const EmptyTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => (theme.name === 'dark' ? '#ffffff' : '#0f172a')};
  margin: 0 0 8px 0;
`;

export const EmptyDescription = styled.p`
  font-size: 14px;
  color: ${({ theme }) => (theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  margin: 0;
  max-width: 400px;
`;

// Expandable details panel
export const DetailsPanel = styled.div`
  max-height: ${({ expanded }) => (expanded ? '500px' : '0')};
  opacity: ${({ expanded }) => (expanded ? 1 : 0)};
  overflow: hidden;
  transition: all 0.3s ease;
`;

export const DetailsContent = styled.div`
  padding: 16px;
  border-top: 1px solid
    ${({ theme }) => (theme.name === 'dark' ? '#334155' : '#e2e8f0')};
  background: ${({ theme }) =>
    theme.name === 'dark' ? 'rgba(0, 0, 0, 0.15)' : 'rgba(0, 0, 0, 0.02)'};
`;

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DetailLabel = styled.span`
  font-size: 10px;
  font-weight: 600;
  color: ${({ theme }) => (theme.name === 'dark' ? '#64748b' : '#94a3b8')};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const DetailValue = styled.div`
  font-size: 14px;
  color: ${({ theme }) => (theme.name === 'dark' ? '#e2e8f0' : '#334155')};
  line-height: 1.5;
  word-break: break-word;
`;

export const DetailLink = styled.a`
  font-size: 13px;
  color: #fa4616;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &:hover {
    text-decoration: underline;
  }
`;

export const DetailText = styled.p`
  font-size: 13px;
  color: ${({ theme }) => (theme.name === 'dark' ? '#cbd5e1' : '#334155')};
  line-height: 1.5;
  margin: 0;
  background: ${({ theme }) =>
    theme.name === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.03)'};
  padding: 10px 12px;
  border-radius: 6px;
  max-height: 120px;
  overflow-y: auto;
`;

export const MediaPreview = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const MediaItem = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 6px;
  overflow: hidden;
  background: ${({ theme }) => (theme.name === 'dark' ? '#0f172a' : '#f8fafc')};
  border: 1px solid
    ${({ theme }) => (theme.name === 'dark' ? '#334155' : '#e2e8f0')};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const MediaLabel = styled.span`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 2px;
  font-size: 8px;
  font-weight: 600;
  text-align: center;
  background: rgba(0, 0, 0, 0.75);
  color: #ffffff;
  text-transform: uppercase;
`;

export const PdfPreview = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 6px;
  background: ${({ theme }) =>
    theme.name === 'dark' ? 'rgba(239, 68, 68, 0.15)' : '#fee2e2'};
  border: 1px solid
    ${({ theme }) => (theme.name === 'dark' ? '#7f1d1d' : '#fecaca')};
  color: ${({ theme }) => (theme.name === 'dark' ? '#fca5a5' : '#dc2626')};
  text-decoration: none;
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  gap: 2px;
  transition: all 0.15s ease;

  &:hover {
    background: ${({ theme }) =>
      theme.name === 'dark' ? 'rgba(239, 68, 68, 0.25)' : '#fecaca'};
  }
`;

export const VideoPreview = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 6px;
  background: ${({ theme }) =>
    theme.name === 'dark' ? 'rgba(251, 146, 60, 0.15)' : '#ffedd5'};
  border: 1px solid
    ${({ theme }) => (theme.name === 'dark' ? '#9a3412' : '#fed7aa')};
  color: ${({ theme }) => (theme.name === 'dark' ? '#fdba74' : '#ea580c')};
  text-decoration: none;
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  gap: 2px;
  transition: all 0.15s ease;

  &:hover {
    background: ${({ theme }) =>
      theme.name === 'dark' ? 'rgba(251, 146, 60, 0.25)' : '#fed7aa'};
  }
`;

export const NoContent = styled.span`
  font-size: 14px;
  color: ${({ theme }) => (theme.name === 'dark' ? '#475569' : '#cbd5e1')};
  font-style: italic;
`;

// Media Modal
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
  animation: fadeIn 0.2s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ModalContent = styled.div`
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: scaleIn 0.2s ease;

  @keyframes scaleIn {
    from {
      transform: scale(0.95);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: -40px;
  right: 0;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const ModalImage = styled.img`
  max-width: 100%;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
`;

export const ModalPdfFrame = styled.iframe`
  width: 80vw;
  height: 85vh;
  max-width: 1000px;
  border: none;
  border-radius: 8px;
  background: white;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
`;

export const ModalVideoFrame = styled.iframe`
  width: 80vw;
  height: 45vw;
  max-width: 900px;
  max-height: 506px;
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
`;

export const ModalLabel = styled.div`
  margin-top: 16px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
`;

// Clickable media items
export const ClickableMediaItem = styled.button`
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 6px;
  overflow: hidden;
  background: ${({ theme }) => (theme.name === 'dark' ? '#0f172a' : '#f8fafc')};
  border: 1px solid
    ${({ theme }) => (theme.name === 'dark' ? '#334155' : '#e2e8f0')};
  padding: 0;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ClickablePdfPreview = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 6px;
  background: ${({ theme }) =>
    theme.name === 'dark' ? 'rgba(239, 68, 68, 0.15)' : '#fee2e2'};
  border: 1px solid
    ${({ theme }) => (theme.name === 'dark' ? '#7f1d1d' : '#fecaca')};
  color: ${({ theme }) => (theme.name === 'dark' ? '#fca5a5' : '#dc2626')};
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  gap: 2px;
  cursor: pointer;
  transition: all 0.15s ease;
  padding: 0;

  &:hover {
    transform: scale(1.05);
    background: ${({ theme }) =>
      theme.name === 'dark' ? 'rgba(239, 68, 68, 0.25)' : '#fecaca'};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
`;

export const ClickableVideoPreview = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 6px;
  background: ${({ theme }) =>
    theme.name === 'dark' ? 'rgba(251, 146, 60, 0.15)' : '#ffedd5'};
  border: 1px solid
    ${({ theme }) => (theme.name === 'dark' ? '#9a3412' : '#fed7aa')};
  color: ${({ theme }) => (theme.name === 'dark' ? '#fdba74' : '#ea580c')};
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  gap: 2px;
  cursor: pointer;
  transition: all 0.15s ease;
  padding: 0;

  &:hover {
    transform: scale(1.05);
    background: ${({ theme }) =>
      theme.name === 'dark' ? 'rgba(251, 146, 60, 0.25)' : '#fed7aa'};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
`;

// Source badge for distinguishing track, series, vs event infos
export const SourceBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  font-size: 10px;
  font-weight: 600;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  flex-shrink: 0;

  ${({ source, theme }) => {
    if (source === 'track') {
      return `
        background: ${
          theme.name === 'dark' ? 'rgba(59, 130, 246, 0.15)' : '#dbeafe'
        };
        color: ${theme.name === 'dark' ? '#93c5fd' : '#2563eb'};
        border: 1px solid ${
          theme.name === 'dark' ? 'rgba(59, 130, 246, 0.3)' : '#bfdbfe'
        };
      `;
    }
    if (source === 'series') {
      return `
        background: ${
          theme.name === 'dark' ? 'rgba(139, 92, 246, 0.15)' : '#ede9fe'
        };
        color: ${theme.name === 'dark' ? '#c4b5fd' : '#7c3aed'};
        border: 1px solid ${
          theme.name === 'dark' ? 'rgba(139, 92, 246, 0.3)' : '#ddd6fe'
        };
      `;
    }
    // event (default)
    return `
      background: ${
        theme.name === 'dark' ? 'rgba(250, 70, 22, 0.15)' : '#ffedd5'
      };
      color: ${theme.name === 'dark' ? '#fdba74' : '#ea580c'};
      border: 1px solid ${
        theme.name === 'dark' ? 'rgba(250, 70, 22, 0.3)' : '#fed7aa'
      };
    `;
  }}
`;

// Delete button for event-specific infos
export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? 'rgba(239, 68, 68, 0.1)'
      : 'rgba(239, 68, 68, 0.08)'};
  border: 1px solid
    ${({ theme }) =>
      theme.name === 'dark'
        ? 'rgba(239, 68, 68, 0.3)'
        : 'rgba(239, 68, 68, 0.2)'};
  color: ${({ theme }) => (theme.name === 'dark' ? '#fca5a5' : '#dc2626')};
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;

  &:hover {
    background: ${({ theme }) =>
      theme.name === 'dark'
        ? 'rgba(239, 68, 68, 0.2)'
        : 'rgba(239, 68, 68, 0.15)'};
    border-color: ${({ theme }) =>
      theme.name === 'dark'
        ? 'rgba(239, 68, 68, 0.5)'
        : 'rgba(239, 68, 68, 0.4)'};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// Mobile reorder mode styles
export const ReorderToggle = styled.button`
  display: none;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  margin-left: auto;

  background: ${({ theme, $active }) =>
    $active
      ? theme.name === 'dark'
        ? 'rgba(250, 70, 22, 0.15)'
        : 'rgba(250, 70, 22, 0.08)'
      : theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.06)'
      : 'rgba(0, 0, 0, 0.04)'};
  color: ${({ theme, $active }) =>
    $active ? '#fa4616' : theme.name === 'dark' ? '#94a3b8' : '#64748b'};
  border: 1px solid
    ${({ theme, $active }) =>
      $active
        ? theme.name === 'dark'
          ? 'rgba(250, 70, 22, 0.3)'
          : 'rgba(250, 70, 22, 0.2)'
        : theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.08)'};

  svg {
    width: 14px;
    height: 14px;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const ReorderHint = styled.div`
  display: none;
  font-size: 12px;
  color: ${({ theme }) => (theme.name === 'dark' ? '#64748b' : '#94a3b8')};
  text-align: center;
  padding: 8px 0 4px;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const ReorderCard = styled.div`
  background: ${({ theme }) => (theme.name === 'dark' ? '#1e293b' : '#ffffff')};
  border: 1px solid
    ${({ theme }) => (theme.name === 'dark' ? '#475569' : '#cbd5e1')};
  border-radius: 8px;
  display: flex;
  align-items: center;
  overflow: hidden;
`;

export const ReorderDragStrip = styled.div`
  width: 40px;
  align-self: stretch;
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.04)'
      : 'rgba(0, 0, 0, 0.03)'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-right: 1px solid
    ${({ theme }) =>
      theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.06)'
        : 'rgba(0, 0, 0, 0.06)'};
  color: ${({ theme }) => (theme.name === 'dark' ? '#64748b' : '#94a3b8')};
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

export const ReorderCardContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  min-width: 0;
`;

export const ReorderOrderNum = styled.span`
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: linear-gradient(135deg, #fa4616, #ea580c);
  color: white;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ReorderNameArea = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ReorderName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => (theme.name === 'dark' ? '#ffffff' : '#0f172a')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ReorderSub = styled.div`
  font-size: 11px;
  color: ${({ theme }) => (theme.name === 'dark' ? '#64748b' : '#94a3b8')};
  margin-top: 2px;
  text-transform: capitalize;
`;

export const ReorderDoneButton = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  margin-top: 12px;
  background: linear-gradient(135deg, #fa4616, #ea580c);
  color: white;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }

  svg {
    width: 16px;
    height: 16px;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;
